// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import Close from "@mcmc/XDL/Icons/Close";
import { xBaseTheme } from "@mcmc/XDL/types";
import { styledScrollbar } from "@mcmc/XDL/Utilities";
import { css } from "styled-components";

const MODAL_DESKTOP_PADDING = 80;
const MODAL_MOBILE_PADDING = 30;
export default {
    sizeVariants: {
        small: 800,
        medium: 800,
        large: 1200,
    },
    defaultProps: {
        cssOverrides: {
            modalBody: css`
                background: ${getColor("text.inverse")};
                overflow: hidden;
                ${({ theme }: any) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                max-width: 100%;
                                height: auto;
                                max-height: calc(100% - 30px);
                                margin: 15px;
                                box-shadow: ${theme?.shadows[3]};
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )};
            `,
            headlineTypography: css`
                margin-bottom: 16px;
                display: inline-block;
            `,
            titleButton: css`
                & {
                    line-height: 1;
                    position: absolute;
                    top: 0;
                    right: 0;
                    margin: 0;
                }
            `,
            modalTitle: css`
                border: none;
                padding: 100px ${MODAL_DESKTOP_PADDING}px 0 ${MODAL_DESKTOP_PADDING}px;
                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding-left: ${MODAL_MOBILE_PADDING}px;
                                padding-right: ${MODAL_MOBILE_PADDING}px;

                                h3 {
                                    font-size: 24px;
                                    line-height: 28px;
                                }
                            `,
                            null,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )};
            `,
            modalContent: css`
                padding: 0px ${MODAL_DESKTOP_PADDING}px 0 ${MODAL_DESKTOP_PADDING}px;
                flex: 1;
                display: flex;
                flex-direction: column;
                &:after {
                    content: "";
                    display: block;
                    padding-bottom: 80px;
                    z-index: -1;
                    pointer-events: none;
                }
                ${styledScrollbar()}
                .modal-actions {
                    display: flex;
                    flex: 0 0 auto;
                    flex-wrap: wrap;
                    justify-content: flex-start;
                    margin: 40px -${MODAL_DESKTOP_PADDING}px -80px -${MODAL_DESKTOP_PADDING}px;
                    padding: 10px ${MODAL_DESKTOP_PADDING - 5}px;
                    background: ${getColor("common.background")};
                    button {
                        margin: 10px 5px;
                    }
                }
                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding-left: ${MODAL_MOBILE_PADDING}px;
                                padding-right: ${MODAL_MOBILE_PADDING}px;
                                .modal-actions {
                                    flex-direction: column;
                                    margin-left: -${MODAL_MOBILE_PADDING}px;
                                    margin-right: -${MODAL_MOBILE_PADDING}px;
                                    padding-left: ${MODAL_MOBILE_PADDING - 5}px;
                                    padding-right: ${MODAL_MOBILE_PADDING - 5}px;
                                }
                            `,
                            null,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )};
            `,
        },
        sizeVariant: "medium",
        closeButtonProps: {
            buttonType: "solid",
            sizeVariant: "large",
            shape: "rectangle",
            variant: "secondary",
            color: "common.ui1",
            size: 75,
        },
        closeButtonIconProps: {
            src: Close,
            size: 18,
        },
        headlineTypographyProps: {
            variant: "h1",
            forwardAs: "h3",
        },
    },
} as xBaseTheme["modal"];
